import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ThreadError } from '@/exceptions/thread/thread.enum';
import { threadService } from '@/services/thread.service';

const useDeleteThread = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (threadId: number) =>
			await threadService.deleteThread(threadId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['thread'] });
		},

		onError: () => {
			throw new Error(ThreadError.DELETE_ERROR);
		},
	});
};

export default useDeleteThread;
